import React from 'react';
import blog from '../../assests/img/blog.jpg';
import { Card } from 'react-bootstrap';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Person2Icon from '@mui/icons-material/Person2';
import { useNavigate } from 'react-router-dom';

const BlogPostTitle = () => {

    const navigate = useNavigate();

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Blog Post Title</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Blog Post Title
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>

                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-lg-9 col-md-12 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <div className="blog_card_sec_title">
                                                    <div className="blog_card_title">
                                                        <Card>
                                                            <Card.Body>
                                                                <div className='card_bg'>
                                                                    <img src={blog} alt='blog' width="100%" style={{ borderRadius: "10px 10px 0 0" }} />
                                                                    <div className='card_sec_title'>
                                                                        <p>
                                                                            <CalendarMonthIcon /> 15 October, 2024 <span> / </span> <Person2Icon /> KCM School Blog
                                                                        </p>
                                                                        <h6>Blog content goes here It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using ‘Content here, content here’, making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for ‘lorem ipsum’ will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</h6>
                                                                    </div>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="col-lg-3 col-md-12 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    Archives
                                                </div>
                                                <ul className='ps-3'>
                                                    <li><span>October 2024</span></li>
                                                </ul>
                                                <div className="subMenubg active mt-5">
                                                    Blog
                                                </div>
                                                <ul className='ps-3'>
                                                    <li><span onClick={() => navigate('/blog')}>October 2024</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default BlogPostTitle;